import { TimetableStates } from '@/components/Timetable/models/TimetableStates';

export class TimetableState {
    id: number;
    name: string;

    klass: object = TimetableState;

    constructor(id: number, name: string) {
      this.id = id;
      this.name = name;
    }

    get nameLowerCase(){
        return this.name.toLowerCase();
    }

    get alertClass(){
        switch (this.name){
            case TimetableStates.Undefined.name:
            case TimetableStates.New.name:
                return 'lighten-2 black--text';
                break;
            default:
                return '';
                break;
        }
    }

    get color(){
      switch (this.name){
          case TimetableStates.Undefined.name:
          case TimetableStates.New.name:
              return "grey"
              break;
          case TimetableStates.Ordered.name: 
              return "orange"
              break;
          case TimetableStates.Accepted.name: 
              return "green"
          case TimetableStates.AcceptedModified.name:
          case TimetableStates.AcceptedOld.name: 
              return "blue";
          case TimetableStates.Rejected.name:
              return "red"
          case TimetableStates.RejectedModified.name:
          case TimetableStates.RejectedOld.name:
              return "blue"
          default:
              return "pink";
              break;
      }
  }
}

export default TimetableState;
